<template>
  <section class="content-header">
    <h1>Rentabilidad global</h1>
  </section>

  <section class="content">
    <div class="box box-primary">
      <div class="box-body">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label for="compania">Compañía</label>
              <Dropdown v-model="companyia" inputId="compania"
                :options="companyias" optionLabel="nombre" optionValue="id_companyia"
                filter placeholder="Todas las compañías" class="w-100" />
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-group">
              <label for="empresa">Empresa</label>
              <Dropdown v-model="empresa" inputId="empresa"
                :options="empresas" optionLabel="nombre" optionValue="id_empresa"
                filter class="w-100" />
            </div>
          </div>

          <div class="col-md-2">
            <div class="form-group">
              <label for="fecha_inicio">Fecha inicio</label>
              <Calendar v-model="fechaInicio" inputId="fecha_inicio"
                dateFormat="dd/mm/yy" showIcon class="w-100" />
            </div>
          </div>

          <div class="col-md-2">
            <div class="form-group">
              <label for="fecha_fin">Fecha fin</label>
              <Calendar v-model="fechaFin" inputId="fecha_fin"
                dateFormat="dd/mm/yy" showIcon class="w-100" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="botonera">
              <button class="btn btn-primary" @click="cargarInforme('pdf')" :disabled="generando">
                <i class="fa" :class="generando === 'pdf' ? 'fa-spinner fa-spin' : 'fa-file-pdf-o'"></i>
                Generar PDF
              </button>
              <button class="btn btn-success" @click="cargarInforme('xls')" :disabled="generando">
                <i class="fa" :class="generando === 'xls' ? 'fa-spinner fa-spin' : 'fa-file-excel-o'"></i>
                Generar Excel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <form id="FormInforme" method="post" style="display:none"></form>
    <iframe name="iframeInforme" style="display:none"></iframe>
  </section>
</template>

<script>
import { PwgsApi } from '../../../services/PwgsApi';
import Dropdown from 'primevue/dropdown';
import Calendar from 'primevue/calendar';

export default {
  components: { Dropdown, Calendar },

  data() {
    const hoy = new Date();
    return {
      companyias: [],
      companyia: '',
      empresas: [],
      empresa: '',
      fechaInicio: new Date(hoy.getFullYear(), hoy.getMonth(), 1),
      fechaFin: hoy,
      generando: false
    };
  },

  methods: {
    formatearFecha(fecha) {
      if (!fecha) return '';
      const d = String(fecha.getDate()).padStart(2, '0');
      const m = String(fecha.getMonth() + 1).padStart(2, '0');
      return `${d}/${m}/${fecha.getFullYear()}`;
    },

    async cargarInforme(tipo) {
      const destino = tipo === 'pdf' ? 'VentanaInforme' : 'iframeInforme';
      if (tipo === 'pdf') window.open('', 'VentanaInforme');

      this.generando = tipo;
      try {
        const api = new PwgsApi();

        const html = await api.post('informes/informe_rentabilidad_global', {
          tipo_respuesta: tipo,
          id_companyia: this.companyia,
          id_empresa: this.empresa,
          fecha_inicio: this.formatearFecha(this.fechaInicio),
          fecha_fin: this.formatearFecha(this.fechaFin)
        });

        const doc = new DOMParser().parseFromString(html, 'text/html');
        const formOrigen = doc.querySelector('#form_informe');
        if (!formOrigen) {
          console.error('La API no devolvió el formulario esperado', html);
          return;
        }

        let direccion = localStorage.getItem('direccion');
        if (direccion == 'null.pwgs.app') direccion = 'pwgs5.local';

        const form = document.getElementById('FormInforme');
        form.innerHTML = '';
        form.target = destino;
        form.action = 'https://' + direccion + formOrigen.getAttribute('action');

        const anyadir = (nombre, valor) => {
          const i = document.createElement('input');
          i.type = 'hidden';
          i.name = nombre;
          i.value = valor;
          form.appendChild(i);
        };

        // Del HTML de la API solo aprovechamos las fechas.
        // El resto lo montamos igual que el formulario antiguo:
        // ids_companias, nombre_compania, empresa, generar_informe
        formOrigen.querySelectorAll('input').forEach(input => {
          if (input.name === 'inicio' || input.name === 'final') {
            anyadir(input.name, input.value);
          }
        });

        const seleccionada = this.companyias.find(c => c.id_companyia === this.companyia);

        anyadir('ids_companias', this.companyia || 'Todas');
        anyadir('nombre_compania', seleccionada ? seleccionada.nombre : 'Todas');
        anyadir('empresa', this.empresa);
        anyadir('generar_informe', tipo === 'pdf' ? 'pdf' : 'excel');

        form.submit();
      } finally {
        this.generando = false;
      }
    },

    async cargarFiltros() {
      const api = new PwgsApi();
      const respuesta = await api.get('informes/informe_rentabilidad_global');
      const filtros = respuesta.filtros || (respuesta.informes && respuesta.informes.filtros) || [];

      const fCompanyias = filtros.find(f => f.nombre_campo === 'id_companyia');
      const fEmpresas = filtros.find(f => f.nombre_campo === 'id_empresa');

      // La opción vacía de ambas listas significa "todas"
      this.companyias = fCompanyias ? fCompanyias.valores : [];
      this.companyia = '';

      this.empresas = fEmpresas ? fEmpresas.valores : [];
      this.empresa = '';
    }
  },

  mounted() {
    this.cargarFiltros();
  }
};
</script>

<style scoped>
.form-group label {
  display: block;
  font-weight: 600;
  margin-bottom: 5px;
}

.w-100 :deep(.p-dropdown),
.w-100 :deep(.p-calendar),
.w-100 :deep(.p-inputtext) {
  width: 100%;
}

.botonera {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>